"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPP_TYPE = exports.ranges = exports.getSPP = exports.getNextRangeCoach = exports.getNextRange = exports.getCurrentRange = exports.getAgingMinExperience = exports.coachRanges = void 0;
var GAME_TYPE;
(function (GAME_TYPE) {
    GAME_TYPE["FRIENDLY"] = "friendly";
    GAME_TYPE["DIVISION"] = "division";
    GAME_TYPE["OPEN"] = "open";
    GAME_TYPE["PLAYOFF"] = "playoff";
})(GAME_TYPE || (GAME_TYPE = {}));
// STAR PLAYER POINTS
var SPP_TYPE;
(function (SPP_TYPE) {
    SPP_TYPE["BONUS"] = "BONUS";
    SPP_TYPE["INT"] = "INT";
    SPP_TYPE["KO"] = "KO";
    SPP_TYPE["REU"] = "REU";
    SPP_TYPE["SOR"] = "SOR";
    SPP_TYPE["TD"] = "TD";
    SPP_TYPE["FALL"] = "FALL";
    SPP_TYPE["ASSIST"] = "ASSIST";
})(SPP_TYPE || (exports.SPP_TYPE = SPP_TYPE = {}));
const SPP = {
    [GAME_TYPE.FRIENDLY]: {
        EXP_BONUS: 1,
        EXP_INT: 2,
        EXP_KO: 1,
        EXP_REU: 1,
        EXP_SOR: 2,
        EXP_TD: 3,
        EXP_FALL: 0,
        EXP_ASSIST: 0,
    },
    [GAME_TYPE.DIVISION]: {
        EXP_BONUS: 1,
        EXP_INT: 2,
        EXP_KO: 1,
        EXP_REU: 1,
        EXP_SOR: 2,
        EXP_TD: 3,
        EXP_FALL: 0,
        EXP_ASSIST: 0,
    },
    [GAME_TYPE.OPEN]: {
        EXP_BONUS: 1,
        EXP_INT: 2,
        EXP_KO: 1,
        EXP_REU: 1,
        EXP_SOR: 2,
        EXP_TD: 3,
        EXP_FALL: 0,
        EXP_ASSIST: 0,
    },
    [GAME_TYPE.PLAYOFF]: {
        EXP_BONUS: 1,
        EXP_INT: 2,
        EXP_KO: 1,
        EXP_REU: 1,
        EXP_SOR: 2,
        EXP_TD: 3,
        EXP_FALL: 0,
        EXP_ASSIST: 0,
    },
};
const ranges = [6, 16, 31, 51, 76, 176];
exports.ranges = ranges;
const coachRanges = [3, 8, 15, 25, 36, 80];
exports.coachRanges = coachRanges;
const getSPP = (game, type) => {
    return SPP[game.type][`EXP_${type}`];
};
exports.getSPP = getSPP;
const getCurrentRange = (currentExp) => {
    for (let i = 0; i < ranges.length; i++) {
        if (currentExp < ranges[i]) {
            return i + 1;
        }
    }
    return ranges.length + 1;
};
exports.getCurrentRange = getCurrentRange;
const getNextRange = (currentExp) => {
    for (let i = 0; i < ranges.length; i++) {
        if (currentExp < ranges[i]) {
            return ranges[i];
        }
    }
    return "∞";
};
exports.getNextRange = getNextRange;
const getNextRangeCoach = (currentRange) => {
    for (let i = 0; i < coachRanges.length; i++) {
        if (currentRange < coachRanges[i]) {
            return coachRanges[i];
        }
    }
    return "∞";
};
exports.getNextRangeCoach = getNextRangeCoach;
const getAgingMinExperience = () => {
    return ranges[1];
};
exports.getAgingMinExperience = getAgingMinExperience;
